import React from "react";
import ReactDOM from "react-dom/client";
import { HashRouter } from "react-router-dom";
import AppWrapper from "./AppWrapper";
import reportWebVitals from "./reportWebVitals";
import AppContext from "./Config";
import { OfflineProvider } from "./offline/OfflineContext";

if (
  !window.location.hash ||
  window.location.hash === "#/" ||
  window.location.hash === "#"
) {
  window.location.replace("#/login");
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AppContext>
      <OfflineProvider>
        <HashRouter>
          <AppWrapper />
        </HashRouter>
      </OfflineProvider>
    </AppContext>
  </React.StrictMode>,
);

reportWebVitals();
